import styled from "styled-components";

export const DotIndicatorDefaultBox = styled.div`
    position: absolute;
    inset-inline-end: 20px;
    top: 10px;
    width: 10px;
    height: 10px;
    background-color: ${props => props.theme.colors.danger};
    border-radius: 50%;
`